import React from "react";
import { Card } from "antd";
import i18n from "../i18n";
import { SimpleText, OH1 } from "../components/text/OText";
import { Metrics } from "../theme";
export const MockupWarning = ({style, message, center})=>(
	<div style={{
		textAlign: "center", 
		backgroundColor:"#FFEE73",
		padding:5,
		...style,
	}}>
		{message ? message : "** This area is using mockup data or layout. **"}
	</div>
);
export const DevelopmentArea = (props)=>{
	const {
		id,
		style = {
			paddingTop:Metrics.button.spaceMargin,
			paddingBottom:Metrics.button.spaceMargin
		}, 
		bodyStyle, 
		text
	} = props;
	return (<div id={id} style={style}>
		<Card bodyStyle={bodyStyle}>
			<SimpleText style={{textAlign:"center"}} fontSize={14}>
				{text ? text : "Development area"}
			</SimpleText>
		</Card>
	</div>);
};


// WEBPACK FOOTER //
// ./src/util/dev_layout.js